<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import wait from 'waait'

@Component({})
export default class SpaceTitle extends Vue {
  @Prop()
  spaceId: string

  @Prop()
  initials: string

  @Prop()
  fullName: string

  @Prop()
  address: string

  @Prop()
  phone: string

  @Prop()
  url: string

  @Prop()
  partner: string

  @Prop()
  smartHubDeviceId: string

  @Prop()
  smartHubFirmware: string

  @Prop()
  smartHubSerialNo: string

  @Prop()
  mpersImei: string

  @Prop()
  mpersSerialNo: string

  showCopiedPopover = false

  get summaryText() {
    // Build string in a way that we can can preserve line breaks at the right spots.
    return [
      `${this.fullName} #${this.spaceId}`,
      `${this.address}`,
      `Phone: ${this.phone}`,
      this.partner ? `Partner: ${this.partner}` : '',
      `${this.url}`,
      `--`,
      `Smart Hub Serial: ${this.smartHubSerialNo}`,
      `Smart Hub ID: ${this.smartHubDeviceId}`,
      `Smart Hub Firmware: ${this.smartHubFirmware}`,
      this.mpersImei ? '--' : '',
      this.mpersSerialNo ? `mPERS Serial: ${this.mpersSerialNo}` : '',
      this.mpersImei ? `mPERS IMEI: ${this.mpersImei}` : '',
    ]
      .filter((s) => s) // remove empty strings
      .join('\r\n')
  }

  async copy() {
    ;(this as any).$copyText(this.summaryText)

    // Hide popover and show success one.
    this.$root.$emit('bv::hide::popover')
    this.showCopiedPopover = true
    await wait(1500)
    this.showCopiedPopover = false
  }
}
</script>

<template>
  <div>
    <div
      id="space-title"
      @click="copy"
      class="name h2 d-inline-block p-3 ml-n3 rounded cursor-pointer">
      <span class="initials">
        {{ initials }}
      </span>
      {{ fullName | title }}
    </div>

    <b-popover target="space-title" triggers="hover" placement="right">
      <template #title> Click to copy this to clipboard </template>
      <div class="ws-pre-line">
        {{ summaryText }}
      </div>
    </b-popover>

    <b-popover :show.sync="showCopiedPopover" target="space-title" triggers="" placement="right">
      <template #title>Copied!</template>
    </b-popover>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';

.name {
  &:hover {
    background: $gray-300;
  }
  &:active {
    background: $gray-400;
  }

  span {
    @include circle(50px);
    font-size: 22px;
    text-align: center;
    font-weight: bolder;
    background: $primary;
    color: white;
  }
}
</style>
